<template>
  <WindowFrame
    class="ma-0 pa-0"
    :component="'check'"
    :input_args="input_args"
    @loaded="handleCheckLoaded"
    ref="windowframe_check"
  />
</template>
<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "FrameCheckTabellaTest",
  components: { WindowFrame },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      input_args: {
        esterno: 0,
        toolbar_btn_chiudi: true,
        toolbar_visible: false,
      },

      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        landing_page: "consuntivotest",
        dizionario: new Object(),
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>